<script setup lang="ts">
    /**
    Woom specific color picker
    */
    export interface ColorOptionsProps {
        options: OptionValue[];
    }

    defineProps<ColorOptionsProps>();

    const emit = defineEmits(['changed', 'hover']);

    const handleSelected = (option: string) => {
        emit('changed', option);
    };

    const handleHover = (option: string) => {
        emit('hover', option);
    };
</script>

<template>
    <div class="mol-color-options flex flex-wrap content-center justify-items-center gap-2 lg:gap-1">
        <atm-color
            v-for="(option, index) in options"
            :key="index"
            :color-option="option"
            @click="handleSelected"
            @hover="handleHover"
            @hoverLeave="handleHover" />
    </div>
</template>
